// extracted by css-extract-rspack-plugin
export default {"messengers":"messengers--o1TQutHke059tirr","messenger":"messenger--H8mheTXb6IaXlT7x"};